<div class="flex flex-col gap-3 border rounded-md p-4">
  <div class="flex items-center gap-2">
    <i
      class="icon-wl-arrow-drop-down text-6 cursor-pointer transition"
      [ngClass]="isExpanded ? '' : '-rotate-90'"
      (click)="onToggleExpanded()"></i>
    <span class="text-4 font-semibold">
      {{ report.name === 'ALL' ? report.name : index + '. ' + report.name }}
    </span>
    <div
      class="h-6 min-w-6 px-1 w-fit flex items-center justify-center text-neutral-800 bg-neutral-300 rounded-sm font-medium">
      {{ report.data.total }}
    </div>
  </div>

  @if (isExpanded) {
    <p-table [value]="data" [scrollable]="true" (onSort)="onSort($event)">
      <ng-template pTemplate="header">
        <tr class="truncate">
          @for (col of visibleColumns; track $index) {
            @if (col.key === ProductDetailExportFieldEnum.TARGET_PREMIUM) {
              <th
                class="!text-right"
                pFrozenColumn
                [frozen]="true"
                alignFrozen="right"
                frozenColStyle="right"
                [pSortableColumn]="PRODUCT_DETAIL_EXPORT_TO_SORT_FIELD[ProductDetailExportFieldEnum.TARGET_PREMIUM]!">
                <app-sort-table-header
                  [label]="translatePrefix + 'policy.target-premium' | translate"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"
                  [field]="
                    PRODUCT_DETAIL_EXPORT_TO_SORT_FIELD[ProductDetailExportFieldEnum.TARGET_PREMIUM]!
                  "></app-sort-table-header>
              </th>
            } @else {
              <th [pSortableColumn]="PRODUCT_DETAIL_EXPORT_TO_SORT_FIELD[col.key]!">
                <app-sort-table-header
                  [label]="translatePrefix + col.labelKey | translate"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"
                  [field]="PRODUCT_DETAIL_EXPORT_TO_SORT_FIELD[col.key]!"></app-sort-table-header>
              </th>
            }
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="truncate">
          @for (col of visibleColumns; track $index) {
            @switch (col.key) {
              @case (ProductDetailExportFieldEnum.POLICY_NO) {
                <!-- Policy No -->
                <td>{{ item.number }}</td>
              }
              @case (ProductDetailExportFieldEnum.LEAD) {
                <!-- Lead -->
                <td>
                  <div class="flex items-center">
                    <a
                      class="underline text-blue-500"
                      [routerLink]="['/lead-management/lead-details', item.lead?.id, 'overview']"
                      target="_blank">
                      {{ item.lead?.fullName }}</a
                    >
                  </div>
                </td>
              }
              @case (ProductDetailExportFieldEnum.LEAD_ID) {
                <!-- Lead ID -->
                <td>
                  <div class="relative flex items-center w-max group">
                    <span class="pr-6">{{ item.lead.leadId }}</span>
                    <div
                      class="absolute inset-0 flex items-center gap-1 text-4 opacity-0 group-hover:opacity-100 justify-center">
                      <div class="icon-action">
                        <i (click)="onCopy(item.lead.leadId, 'lead-id')" class="icon-wl-duplicate cursor-pointer"></i>
                      </div>
                    </div>
                  </div>
                </td>
              }
              @case (ProductDetailExportFieldEnum.CELLPHONE) {
                <!-- Created date -->
                <td>{{ item.lead?.cellPhone?.length ? (item.lead?.cellPhone ?? '' | phoneNumber) : '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.EMAIL) {
                <!-- Created date -->
                <td>{{ item.lead?.email }}</td>
              }
              @case (ProductDetailExportFieldEnum.STATE) {
                <!-- Created date -->
                <td>{{ item.lead?.state }}</td>
              }
              @case (ProductDetailExportFieldEnum.CREATED_DATE) {
                <!-- Created date -->
                <td>{{ item.createdAt | date: 'MM/dd/yyyy' }}</td>
              }
              @case (ProductDetailExportFieldEnum.OWNER) {
                <!-- Owner -->
                <td>{{ item.owner?.fullName || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.AGENT) {
                <!-- Agent -->
                <td>{{ item.agent?.fullName || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.POLICY_STATUS) {
                <!-- Policy status -->
                @if (item?.status) {
                  <td>
                    <span
                      class="text-2 font-medium rounded-sm px-1.5 py-0.5 w-fit h-5"
                      [ngStyle]="{
                        backgroundColor: item?.status?.parent?.backgroundColor,
                        color: item?.status?.parent?.color
                      }">
                      {{ item?.status?.parent?.name + ' - ' + item?.status?.name }}
                    </span>
                  </td>
                } @else {
                  <td>{{ '--' }}</td>
                }
              }
              @case (ProductDetailExportFieldEnum.POLICY_TRACKING) {
                <!-- Policy tracking -->
                <td>{{ item.policyTracking?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.EFFECTIVE_DATE) {
                <!-- Effective date -->
                <td>{{ (item.effectiveDate | date: 'MM/dd/yyyy') || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.PREMIUM_MODE) {
                <!-- Premium mode -->
                <td>{{ item.mode?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.PREMIUM_PAYMENT) {
                <!-- Premium payment -->
                <td class="text-center">{{ (item.payment | currency) || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.FACE_AMOUNT) {
                <!-- Face amount -->
                <td class="text-center">{{ (item.faceAmount | currency) || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.COMPANY) {
                <!-- Company -->
                <td>{{ item.product?.productType?.company?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.PRODUCT_TYPE) {
                <!-- Product type -->
                <td>{{ item.product?.productType?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.PRODUCT_NAME) {
                <!-- Product name -->
                <td>{{ item.product?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.CONTRIBUTION_YEARS) {
                <!-- Contribution years -->
                <td>{{ item.contributionYear || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.COMMISSION_TEAM) {
                <!-- Commission team -->
                <td>{{ item.commissionTeam?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.COMMISSION_PERCENTAGE) {
                <!-- Commission percentage -->
                <td>{{ item.commissionPercentage?.name || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.COMMISSION_OWNER) {
                <!-- Commission owner -->
                <td>{{ item.commissionOwner?.fullName || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.COMMISSION_AGENT) {
                <!-- Commission agent -->
                <td>{{ item.commissionAgent?.fullName || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.DESCRIPTION) {
                <!-- Description -->
                <td>{{ item?.note || '--' }}</td>
              }
              @case (ProductDetailExportFieldEnum.CREATED_BY) {
                <!-- Created by -->
                <td>{{ item.createdBy?.fullName }}</td>
              }
              @case (ProductDetailExportFieldEnum.TARGET_PREMIUM) {
                <!-- Target premium -->
                <td class="text-center" pFrozenColumn [frozen]="true" alignFrozen="right" frozenColStyle="right">
                  {{ item.target | currency }}
                </td>
              }
            }
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="summary">
        <div class="px-3.5 border-t flex h-11 items-center justify-end bg-neutral-alpha-200A">
          {{ report.totalTarget | currency }}
        </div>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="20">
            <app-empty-table></app-empty-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    @if (report.data.total > 5) {
      <app-custom-paginator
        [(pagination)]="pagination"
        [totalRecords]="report.data.total"
        [options]="options"
        (onChange)="onPagination()"></app-custom-paginator>
    }
  }
</div>
